module.exports = __webpack_public_path__ + "static/img/dontaitu.c36e971.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/lunbo/dontaitu.png
// module id = ybDm
// module chunks = 6